<template>
  <div class="v-window-item py-6 px-3 py-md-12 px-md-6 px-lg-12 v-window-item--active justify-center" style="min-width: 100%; height: 100%">
    <router-view
      v-if="contactId"
      :isUnitaire="true"
      class="mx-auto v-sheet theme--light"
      style="min-width: 50%; max-width: 1230px"
    ></router-view>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex"
import ParamFormulaire from "@/mixins/paramFormulaire"

export default {
  mixins: [ParamFormulaire],
  computed: {
    ...mapGetters({
      contactId: "Unitaire/GET_CONTACTID",
    }),
  },
  async mounted() {
    await this.loadParams(this.$paramFormulaire.codeFormulaireUnitaire)

    try {
      if (this.$route.params.contactId != null) {
        this.setContactId(this.$route.params.contactId)
      }
    } catch (erreur) {
      console.log(erreur)
    }
  },
  methods: {
    ...mapMutations({
      setContactId: "Unitaire/SET_CONTACTID",
    }),
  },
}
</script>

<style></style>
